/**
 * Affix.jsx
 *
 * @Author: zhangce
 * @Date: 18/3/23 下午4:20
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const getElementLeft = element => {
  let actualLeft = element.offsetLeft;
  let current = element.offsetParent;
  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent;
  }
  return actualLeft;
};
const getElementTop = element => {
  let actualTop = element.offsetTop;
  let current = element.offsetParent;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }
  return actualTop;
};

/**
 * Affix
 * */
class Affix extends React.PureComponent {
  static displayName = 'NeatUI.Affix';

  static propTypes = {
    /**
     * 距离窗口底部达到指定偏移量后触发
     * */
    offsetBottom: PropTypes.number,
    /**
     * 距离窗口顶部达到指定偏移量后触发
     * */
    offsetTop: PropTypes.number,
    /**
     * 设置 `Affix` 需要监听其滚动事件的元素，值为一个返回对应 DOM 元素的函数
     * */
    target: PropTypes.func,
    /**
     * 固定状态改变时触发的回调函数
     * */
    onChange: PropTypes.func,
  };

  static defaultProps = {
    prefixCls: 'ne-affix',
    offsetTop: 0,
    target: () => window,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      style: {},
      containerStyle: {},
      affixed: false,
    };
  }

  componentDidMount() {
    const { target } = this.props;
    this.targetEle = target();
    this.targetEle.addEventListener('scroll', this.handleTargetScroll, false);
    this.handleTargetScroll();
  }

  componentDidUpdate(prevProps, prevState) {
    const { onChange } = this.props;
    if (prevState.affixed !== this.state.affixed) {
      onChange && onChange(this.state.affixed);
    }
  }

  handleTargetScroll = () => {
    if (!this.affix) {
      return;
    }
    const { offsetTop, offsetBottom } = this.props;
    const isWindowContainer = this.targetEle === window;
    const affixHeight = this.affix.clientHeight;
    const affixClientWidth = this.affix.clientWidth;
    const scrollTop = isWindowContainer
      ? document.documentElement.scrollTop
      : this.targetEle.scrollTop;
    const targetOffsetHeight = window.frameElement
      ? window.frameElement.offsetHeight
      : document.documentElement.clientHeight;
    let condition;
    const style = {
      position: 'fixed',
      left: getElementLeft(this.affix),
      zIndex: 10,
    };

    if (offsetBottom === void 0) {
      condition = scrollTop > getElementTop(this.affix) - offsetTop;
      style.top = isWindowContainer ? offsetTop : getElementTop(this.targetEle) + offsetTop;
    } else {
      condition =
        targetOffsetHeight - (getElementTop(this.affix) - scrollTop) - affixHeight <= offsetBottom;
      style.bottom = isWindowContainer
        ? offsetBottom
        : getElementTop(this.targetEle) +
          this.targetEle.offsetHeight -
          this.affix.offsetHeight -
          offsetBottom;
    }

    if (condition) {
      this.setState({
        style,
        containerStyle: {
          width: affixClientWidth,
          height: affixHeight,
        },
        affixed: true,
      });
    } else {
      this.setState({
        style: {},
        containerStyle: {},
        affixed: false,
      });
    }
  };

  render() {
    const { children, offsetBottom, offsetTop, target, onChange, prefixCls, ...other } = this.props;
    const { style, containerStyle, affixed } = this.state;
    const classStr = classNames({ [prefixCls]: affixed });
    return (
      <div style={containerStyle} ref={ref => (this.affix = ref)} {...other}>
        <div className={classStr} style={style}>
          {children}
        </div>
      </div>
    );
  }
}

export default Affix;



// WEBPACK FOOTER //
// ./src/affix/Affix.jsx